import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
export function ToolCallDisplay({ toolCalls, isStreaming }) {
    if (toolCalls.length === 0)
        return null;
    const wrapperRef = useRef(null);
    const wasStreaming = useRef(isStreaming);
    // Collapse the outer wrapper when streaming ends
    useEffect(() => {
        if (wasStreaming.current && !isStreaming && wrapperRef.current) {
            wrapperRef.current.open = false;
        }
        wasStreaming.current = isStreaming;
    }, [isStreaming]);
    const doneCount = toolCalls.filter((tc) => tc.status === "done").length;
    const deniedCount = toolCalls.filter((tc) => tc.status === "denied").length;
    const errorCount = toolCalls.filter((tc) => tc.status === "error").length;
    const summaryParts = [];
    summaryParts.push(`${toolCalls.length} tool call${toolCalls.length === 1 ? "" : "s"}`);
    if (deniedCount > 0)
        summaryParts.push(`${deniedCount} denied`);
    if (errorCount > 0)
        summaryParts.push(`${errorCount} failed`);
    if (isStreaming)
        summaryParts.push("in progress…");
    else if (doneCount + deniedCount + errorCount < toolCalls.length)
        summaryParts.push("in progress…");
    return (_jsxs("details", { ref: wrapperRef, className: "tool-calls-wrapper", open: isStreaming || undefined, children: [_jsxs("summary", { className: "tool-calls-summary", children: ["\uD83D\uDD27 ", summaryParts.join(" · ")] }), _jsx("div", { className: "tool-calls", children: toolCalls.map((tc) => (_jsxs("details", { className: `tool-call tool-call--${tc.status}`, children: [_jsxs("summary", { className: "tool-call-summary", children: [_jsx("span", { className: "tool-call-icon", children: tc.status === "calling"
                                        ? "⏳"
                                        : tc.status === "done"
                                            ? "✅"
                                            : tc.status === "denied"
                                                ? "🚫"
                                                : "❌" }), _jsx("span", { className: "tool-call-name", children: tc.toolName }), _jsxs("span", { className: "tool-call-args-preview", children: ["(", JSON.stringify(tc.arguments), ")"] })] }), _jsxs("div", { className: "tool-call-detail", children: [_jsx("div", { className: "tool-call-args", children: JSON.stringify(tc.arguments, null, 2) }), tc.result !== undefined && (_jsx("pre", { className: "tool-call-result", children: typeof tc.result === "string"
                                        ? tc.result
                                        : JSON.stringify(tc.result, null, 2) }))] })] }, tc.toolCallId || tc.toolName))) })] }));
}
//# sourceMappingURL=ToolCallDisplay.js.map